<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="8" class="pt-1">
          <span class="headline font-weight-medium">Planillas</span>
        </v-col>

        <!-- <v-col cols="2" class="pt-1">
            <v-btn v-if="this.$hasPermision('empleados.create')" dark color="#023145" width="140" class="float-right" @click="handleShowCreate">
                Nuevo
            </v-btn>
        </v-col> -->
      </v-row>
      <v-row>
        <v-col cols="2" class="pt-1"> </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels focusable>
            <v-expansion-panel v-for="(item, i) in anios" :key="i">
              <v-expansion-panel-header
                ><h1>{{ item }}</h1></v-expansion-panel-header
              >
              <v-expansion-panel-content style="padding-top: 1%">
                <v-card v-for="planilla of planillas" v-bind:key="planilla.id">
                  <v-list>
                    <v-list-item-group
                      color="indigo"
                      v-if="planilla.anio == item"
                    >
                      <v-list-item cols="8">
                        <!-- <v-list-item-icon>
                          <v-icon v-if="planilla.estado == true"
                            >fas fa-unlock</v-icon
                          >
                          <v-icon v-if="planilla.estado == false"
                            >fas fa-lock</v-icon
                          >
                        </v-list-item-icon> -->

                        <v-list-item-content @click="almacena(planilla)">
                          <v-list-item-title v-if="planilla.estado == true"
                            >{{
                              planilla.nombre_mes.toUpperCase()
                            }}
                            (ABIERTO)</v-list-item-title
                          >
                          <v-list-item-title v-if="planilla.estado == false"
                            >{{
                              planilla.nombre_mes.toUpperCase()
                            }}
                            (CERRADO)</v-list-item-title
                          >
                          <span
                            >{{ planilla.fecha_inicio }} 12:00:00 am -
                            {{ planilla.fecha_fin }} 11:59:59 pm</span
                          >
                        </v-list-item-content>
                        <v-col cols="2" class="pt-1">
                          <h2 style="float:right;">
                            {{ planilla.monto_total }}
                          </h2>
                        </v-col>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </template>
    <pagar ref="Pagar"></pagar>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OfficeLogin from "../../components/auth/OfficeLogin";
import ArrayTools from "../../helpers/ArrayTools";
import router from "@/router/index";
import Pagar from "../../components/planillas/Pagar";
//import CreateUpdate from '../../../components/employees/CreateUpdate'
//import Filters from '../../../components/employees/Filters'

export default {
  name: "Employees",
  components: {
    OfficeLogin,
    Pagar,
  },
  data() {
    return {
      search_employee: null,
      drawer: false,
      show_options_crud: false,
      show_btn_active: false,
      selectedRows: [],
      itemsBreadcrumbs: [
        {
          text: "Planillas",
          disabled: true,
          href: "",
        },
      ],
      headers: [
        { text: "NOMBRES Y APELLIDOS", value: "fullname", sortable: false },
        { text: "DNI", value: "dni", sortable: false },
        { text: "FEC. NACIMIENTO", value: "birthday", sortable: false },
        { text: "TELÉFONO", value: "phone", sortable: false },
        { text: "ACCESO AL SISTEMA", value: "has_access", sortable: false },
        { text: "USUARIO", value: "username", sortable: false },
        { text: "ROL", value: "role_name", sortable: false },
        { text: "TIPO DE PAGO", value: "payment_type", sortable: false },
      ],
      items: [
        {
          icon: "mdi-look",
          text: "Wifi",
        },
      ],
      newArray: [],
      anios: [],
    };
  },
  computed: {
    ...mapState("planillas", ["planillas"]),
    ...mapState("planillaDetalle", ["itemsPlanilla"]),
  },
  methods: {
    ...mapActions("planillas", ["getPlanillas"]),
    ...mapActions("planillaDetalle", ["getItems", "reabrirPlanilla"]),
    async reabrirPlanillaBtn(planilla) {
      this.reabrirPlanilla(planilla);
      await this.getPlanillas();
    },
    modalPagar(monto) {
      this.$refs.Pagar.showForm("Pagar Planilla", monto);
    },
    showOptionCrud() {
      this.show_options_crud = this.selectedRows.length > 0;
      if (this.show_options_crud) {
        this.show_btn_active = !this.selectedRows[0].active;
      }
    },
    async almacena(planilla) {
      console.log("planilla ", planilla);
      localStorage.setItem("id_planilla", planilla.id);
      localStorage.setItem("nombre_mes", planilla.nombre_mes);
      localStorage.setItem("anio", planilla.anio);
      localStorage.setItem("cerrado", false);
      await this.getItems(planilla.id);
      router.push("/app/planillas/PlanillaDetalle");
    },
    handleSelectItem(selected) {
      if (selected.value) {
        this.selectedRows.push(selected.item);
      } else {
        let index_found = ArrayTools.getIndexById(
          this.selectedRows,
          selected.item.id
        );
        if (index_found > -1) {
          this.selectedRows.splice(index_found, 1);
        }
      }
      this.showOptionCrud();
    },
    handleShowCreate() {
      this.$refs.createUpdate.showForm("Nuevo empleado", "create");
    },
    handleEdit() {
      let employee = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      this.$refs.createUpdate.showForm(
        "Modificar datos de empleado",
        "update",
        employee
      );
    },
    handleShowFilters() {
      this.$refs.filters.showForm("Filtrar datos de empleados");
    },
    async getAllPlanillas() {
      await this.getPlanillas();

      this.newArray = this.itemsPlanilla;
      let data = this.planillas;

      let anioIndica = null;
      for (let i = 0; i < data.length; i++) {
        let anio = data[i].anio;
        if (anio != anioIndica) {
          this.anios.push(anio);
          anioIndica = anio;
        }
      }
    },
    async handleSearch() {
      this.selectedRows = [];
      this.showOptionCrud();
      let filters = {
        fullname: this.search_employee,
      };
      await this.getPlanillas(filters);
    },
    async handleChangeStatus() {
      let employee = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      await this.change_status(employee);
    },
    async handleDelete() {
      let employee = this.selectedRows[0];
      await this.delete(employee);
      this.selectedRows = [];
      this.showOptionCrud();
    },
  },
  created() {
    this.getAllPlanillas();
  },
};
</script>

<style scoped></style>
